import { GroupItem } from '@/components/organisms';
import { RoutesEnum } from '@/enums';
import { UserRole } from '@/types/users';
import type { FeatureFlagsState } from '@/utils/featureFlags';

export type DashboardSidebarFilterOptions = {
  hideGettingStarted?: boolean;
  role?: UserRole | null;
  showLeaderInsights?: boolean;
};

function isSurveysGroup(group: GroupItem): boolean {
  return group.items.some(item => (item.url as RoutesEnum) === RoutesEnum.SURVEYS_OVERVIEW);
}

export function filterDashboardSidebarGroups(
  groups: GroupItem[],
  flags: Pick<FeatureFlagsState, 'showDataExplorer' | 'showSurveys'>,
  options?: DashboardSidebarFilterOptions
): GroupItem[] {
  const shouldHideManagement = options?.role === 'user';
  const shouldHideSettings = options?.role === 'user' || options?.role === 'people_experience';
  const result: GroupItem[] = [];

  for (const group of groups) {
    const filteredItems = group.items.filter(item => {
      const route = item.url as RoutesEnum;

      if (!flags.showDataExplorer && route === RoutesEnum.DATA_EXPLORER) {
        return false;
      }

      if (shouldHideManagement && route === RoutesEnum.MANAGEMENT) {
        return false;
      }

      if (shouldHideSettings && route === RoutesEnum.SETTINGS) {
        return false;
      }

      if (options?.showLeaderInsights === false && route === RoutesEnum.LEADER_INSIGHTS) {
        return false;
      }

      return true;
    });

    if (isSurveysGroup(group) && !flags.showSurveys) {
      continue;
    }

    if (filteredItems.length > 0) {
      result.push({
        ...group,
        items: filteredItems,
      });
    }
  }

  if (options?.hideGettingStarted) {
    return result
      .map(group => ({
        ...group,
        items: group.items.filter(item => (item.url as RoutesEnum) !== RoutesEnum.GET_STARTED),
      }))
      .filter(group => group.items.length > 0);
  }

  return result;
}
